import { defineAsyncComponent } from 'vue'
export default {
  checkout: defineAsyncComponent(() => import("/builds/pro/webshop/frontend/src/img/app/layouts/checkout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/builds/pro/webshop/frontend/src/img/app/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/builds/pro/webshop/frontend/node_modules/@xsarus-npm/nuxt-base/src/nuxt-base/app/layouts/empty.vue").then(m => m.default || m))
}